import { render } from "./HeaderBar.vue?vue&type=template&id=06f78131&bindings={\"title\":\"setup\"}"
import script from "./HeaderBar.vue?vue&type=script&lang=js"
export * from "./HeaderBar.vue?vue&type=script&lang=js"
script.render = render

export default script